import { useEffect, useRef, useState } from "react";
import { copy } from "@/lib/i18n";
import { startAurora } from "@/lib/aurora";
import { WaitlistForm } from "@/components/WaitlistForm";
import { SiteFooter } from "@/components/SiteFooter";
import { LangToggle } from "@/components/home/LangToggle";
import { useAmbientSound } from "@/hooks/useAmbientSound";

const useReveal = (rootRef) => {
  useEffect(() => {
    const els = rootRef.current.querySelectorAll(".reveal");
    if (!("IntersectionObserver" in window)) return els.forEach((e) => e.classList.add("in"));
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.4 });
    els.forEach((e) => io.observe(e));
    return () => io.disconnect();
  }, [rootRef]);
};

export default function Landing() {
  const [lang, setLang] = useState("en");
  const t = copy[lang];
  const rootRef = useRef(null);
  const skyRef = useRef(null);
  const auroraRef = useRef(null);
  const sound = useAmbientSound();

  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  useEffect(() => startAurora(skyRef.current, auroraRef.current), []);
  useReveal(rootRef);

  return (
    <div className="home" ref={rootRef} data-testid="landing-page">
      <canvas id="sky" ref={skyRef} aria-hidden="true" />
      <canvas id="aurora" ref={auroraRef} aria-hidden="true" />
      <LangToggle lang={lang} setLang={setLang} sound={sound} t={t} />

      <section className="hero">
        <h1 lang="en" data-testid="hero-tagline"><span>Literally,</span><span>selling dreams!</span></h1>
        <p className="subline" data-testid="hero-subline">{t.subline}</p>
        <a className="cue" href="#brand" aria-label={t.scrollDown} data-testid="scroll-cue" />
      </section>

      <section id="brand" className="brand">
        <div className="soon-wrap">
          <p className="soon reveal" data-testid="coming-soon">{t.comingSoon}</p>
          <div className="reveal d2 form-wrap"><WaitlistForm t={t} lang={lang} /></div>
        </div>
        <SiteFooter t={t} />
      </section>
    </div>
  );
}
